// extracted by mini-css-extract-plugin
module.exports = {"infoWrapper":"ClientEmergencyInfo_infoWrapper__1TI2g","itemTitle":"ClientEmergencyInfo_itemTitle__2roUp","itemText":"ClientEmergencyInfo_itemText__19SWx"};